import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import i18nHttpLoader from 'i18next-http-backend';
import Axios from 'axios';

// Boot in the user's saved language (persisted from userInfo.defaultLanguage in
// App.jsx) so a refresh keeps their language instead of flashing back to English
// until userInfo reloads.
const savedLanguage = (typeof localStorage !== 'undefined' && localStorage.getItem('userLanguage')) || 'english';

i18n
    .use(initReactI18next)
    .use(i18nHttpLoader)
    .init({
        interpolation: {
            escapeValue: false,
            //   format: (value, rawFormat, lng) => {
            //     const [format, ...additionalValues] = rawFormat.split(',').map((v) => v.trim());
            //     switch (format) {
            //       case 'uppercase':
            //         return value.toUpperCase();
            //       case 'price':
            //         return Intl.NumberFormat(lng, {
            //           style: 'currency',
            //           currency: additionalValues[0]
            //         }).format(value);

            //       default:
            //         return value
            //     }
            //   }
        },
        lng: savedLanguage,
        fallbackLng: 'english',
        // initImmediate: true,
        react: {
            useSuspense: false,
        },
        backend: {
            loadPath: '/locales/{{lng}}.json',
            parse: (data) => {
                return data;
            },
            request: (options, url, payload, callback) => {
                Axios.get(url)
                    .then(async (res) => {
                        callback(null, res);
                    })
                    .catch((err) => {
                        callback(err, null);
                    });
            },
        },

    });
export default i18n;

